import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'logzy-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss', '../verify-customer/lead-details/lead-details.component.scss']
})
export class ReportsComponent implements OnInit {

    canvas: string = "Canvas";
    open1: string = "sidepanel";
    reportSubject = new BehaviorSubject(null);
    refreshReportTable = new BehaviorSubject(null);
    isLogs: boolean = false;
    logs: [] = [];
    logColumns = ['downloaded_at', 'status'];

    constructor() { }

    ngOnInit(): void {
    }

    openEdit(data) {
        this.open1 = " sidepanel slidepanelOpen ";
        this.canvas = "Canvas setCanvas";
        // setTimeout(() => {
        //   this.bindCompany.next(data);
        // }, 50);
    }

    showLogs(data) {
        this.open1 = " sidepanel slidepanelOpen ";
        this.canvas = "Canvas setCanvas";
        this.isLogs = true;
        this.logs = data.logs;
    }

    closeEdit() {
        this.open1 = " sidepanel ";
        this.canvas = "Canvas ";
    }

    closeSidePanel(event) {
        this.isLogs = false;
        this.logs = [];
        if (event == true) {
            this.refreshReportTable.next(true);
        }
        if (event == null) {
            this.reportSubject.next(null);
        }
        this.closeEdit();
    }

}
